import script from "./BaseSvg.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSvg.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSvg.vue?vue&type=style&index=0&id=f9052728&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/正式_ls/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9052728"]])

export default __exports__